
/**
 * Utility functions to detect browser environments
 */

/**
 * Checks if the current browser is a social media in-app browser
 * Detects common social media in-app browsers based on User Agent and referrer
 */
export const isSocialMediaBrowser = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }

  const ua = window.navigator.userAgent.toLowerCase();
  const referrer = document.referrer.toLowerCase();

  // Check for common social media app browsers
  const isFacebookApp = ua.includes('fban') || ua.includes('fbav') || referrer.includes('facebook.com');
  const isInstagramApp = ua.includes('instagram') || referrer.includes('instagram.com');
  const isTwitterApp = ua.includes('twitter') || ua.includes('x app') || referrer.includes('twitter.com') || referrer.includes('x.com');
  const isLinkedInApp = ua.includes('linkedin') || referrer.includes('linkedin.com');
  const isPinterestApp = ua.includes('pinterest') || referrer.includes('pinterest.com');
  const isSnapchatApp = ua.includes('snapchat') || referrer.includes('snapchat.com');
  const isTiktokApp = ua.includes('tiktok') || referrer.includes('tiktok.com');
  
  // Also detect common webview patterns
  const isWebview = 
    ua.includes('wv') || 
    ua.includes('webview') ||
    (ua.includes('android') && ua.includes('version/'));

  return (
    isFacebookApp ||
    isInstagramApp ||
    isTwitterApp ||
    isLinkedInApp ||
    isPinterestApp ||
    isSnapchatApp ||
    isTiktokApp ||
    isWebview
  );
};

/**
 * Creates a URL to open the current page in external browser
 * Preserves the current URL including any parameters
 */
export const getExternalBrowserUrl = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  
  // Get the full current URL
  const currentUrl = window.location.href;
  
  // For some platforms, we might need to encode the URL
  return currentUrl;
};

